import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6157869e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6157869e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157869e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBreadcrumbs: require('/var/web/bet777.es/components/elements/breadcrumbs.vue').default,ModalClubBetOptinPopup: require('/var/web/bet777.es/components/modal/club-bet-optin-popup.vue').default})
